import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onSelectedChange", "selected"];
import { PureComponent } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: not typed yet
import SimpleStyledClickable from './internal/SimpleStyledClickable';
import { callIfPossible } from 'foundations-components/transitional/utils/functions';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { Controllable } from 'foundations-components/transitional/components/Controllable';
import { jsx as _jsx } from "react/jsx-runtime";
class UITextToolbarButtonCore extends PureComponent {
  constructor(...args) {
    super(...args);
    this.handleClick = evt => {
      const {
        onClick,
        onSelectedChange,
        selected = false
      } = this.props;
      onSelectedChange === null || onSelectedChange === void 0 || onSelectedChange(syntheticEvent(!selected));
      callIfPossible(onClick, evt);
    };
  }
  render() {
    const _this$props = this.props,
      {
        selected = false
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(SimpleStyledClickable, Object.assign({}, rest, {
      "aria-pressed": selected,
      onClick: this.handleClick
    }));
  }
}
UITextToolbarButtonCore.displayName = 'UITextToolbarButtonCore';
const UITextToolbarButton = Controllable(UITextToolbarButtonCore, ['selected']);
UITextToolbarButton.displayName = 'UITextToolbarButton';
export default UITextToolbarButton;